import {removeTeamMember, resendInvite, retrySyncForMember} from '@/api/team';
import {useMutation, useQueryClient} from '@tanstack/react-query';

export function useRemoveTeamMember() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (id: string) => removeTeamMember(id),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['teamMembers']});
        }
    });
}

export function useRetrySyncForMember() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (id: string) => retrySyncForMember(id),
        onSuccess: (_, id) => {
            queryClient.invalidateQueries({queryKey: ['teamMembers']});
            queryClient.invalidateQueries({queryKey: ['teamMember', id]});
        }
    });
}

export function useResendInvite() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (id: string) => resendInvite(id),
        onSuccess: (_, id) => {
            queryClient.invalidateQueries({queryKey: ['teamMember', id]});
        }
    });
}
